<form [formGroup]="form" (ngSubmit)="save()">
  <div class="modal-header">
    <h4 class="modal-title">Add Delivery Location</h4>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="cancel()"
    ></button>
  </div>

  <div class="modal-body p-0 bst-pickup-location-form">
    <!-- Pickup -->
    <div class="pt-3 pb-3 ps-4 pe-4">
      <label class="form-label text-body1 d-flex align-items-center">
        <span class="badge bg-primary-light-950 me-2 d-flex">D</span>
        Select Delivery location (Address)*
      </label>

      <ng-select
        placeholder="Select Location"
        formControlName="pickupLocationId"
        [searchable]="true"
      >
        <ng-container *ngFor="let pickupLocation of addressList">
          <ng-option
            *ngIf="
              deliveryLocationOptions.includes(
                pickupLocation?.city.toLowerCase()
              )
            "
            [value]="pickupLocation.addressId"
          >
            <div class="user-name">
              <h5>{{ pickupLocation?.companyName }}</h5>
            </div>
          </ng-option>
        </ng-container>
      </ng-select>

      <div
        class="text-danger small mt-1"
        *ngIf="
          form.get('pickupLocationId')?.touched &&
          form.get('pickupLocationId')?.invalid
        "
      >
        Delivery location is required
      </div>
    </div>
    <!-- /Pickup -->

    <hr />
  </div>

  <div class="modal-footer">
    <div class="d-flex align-items-center justify-content-between w-100">
      <button class="btn btn-primary" type="submit">Save</button>
    </div>
  </div>
</form>
